import { useMutation, useQueryClient } from '@tanstack/react-query';
import { agreeNotificationAlarm } from 'shared/src/api/myPageService/agreeNotificationAlarm';
import { disagreeNotificationAlarm } from 'shared/src/api/myPageService/disagreeNotificationAlarm';
import { queryKey } from '../../../constant/queryKey';
import type { GetAlarmSettingsResponse } from 'shared/src/api/myPageService/getAlarmSettings/types';

type ToggleAlarmParams = {
  sectionIndex: number;
  itemIndex: number;
  isAgreed: boolean;
  code: string;
};

export const useToggleAlarmSetting = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ isAgreed, code }: ToggleAlarmParams) => {
      if (isAgreed) {
        return await disagreeNotificationAlarm(code);
      } else {
        return await agreeNotificationAlarm(code);
      }
    },
    onSuccess: (_, { sectionIndex, itemIndex }) => {
      client.setQueryData<GetAlarmSettingsResponse>(
        queryKey.alarmSettings(),
        old => {
          if (!old) return old;

          const updatedItemList = old.item_list.map((section, sIndex) => {
            if (sIndex !== sectionIndex) return section;

            return {
              ...section,
              alarm_list: section.alarm_list.map((alarm, aIndex) => {
                if (aIndex !== itemIndex) return alarm;
                return { ...alarm, is_on: !alarm.is_on };
              }),
            };
          });

          return {
            ...old,
            item_list: updatedItemList,
          };
        },
      );
    },
  });
};
